import React, { useState } from "react";
import "./Nav.css";

export default function Nav({ language, setLanguage }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleLanguage = () => {
    setLanguage(language === "no" ? "en" : "no");
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="top-nav">
      <div className="nav-left">
        {/* Desktop-lenkene forblir uendret */}
        <div className="desktop-links">
          <a href="#top">{language === "no" ? "Hjem" : "Home"}</a>
          <a href="#om-oss">{language === "no" ? "Om oss" : "About us"}</a>
          <a href="#services">{language === "no" ? "Tjenester og priser" : "Services and Prices"}</a>
          <a href="#personvern">{language === "no" ? "Praktisk info" : "Practical Info"}</a>
          <a href="#contact">{language === "no" ? "Kontakt" : "Contact us"}</a>
        </div>

        {/* Hamburger-knapp kun for mobil */}
        <button className="hamburger" onClick={toggleMenu}>
         <span className="hamburger-text">Meny</span> ☰ 
        </button>
      </div>

      <div className="lang-link">
        <button className="lang-link" onClick={toggleLanguage}>
          {language === "no" ? "English" : "Norsk"}
        </button>
      </div>

      {/* Mobilmeny */}
      {menuOpen && (
        <div className="mobile-menu">
          <a href="#top" onClick={() => setMenuOpen(false)}>{language === "no" ? "Hjem" : "Home"}</a>
          <a href="#om-oss" onClick={() => setMenuOpen(false)}>{language === "no" ? "Om oss" : "About us"}</a>
          <a href="#services" onClick={() => setMenuOpen(false)}>{language === "no" ? "Tjenester og priser" : "Services and Prices"}</a>
          <a href="#personvern" onClick={() => setMenuOpen(false)}>{language === "no" ? "Praktisk info" : "Practical Info"}</a>
          <a href="#contact" onClick={() => setMenuOpen(false)}>{language === "no" ? "Kontakt" : "Contact us"}</a>
        </div>
      )}
    </nav>
  );
}
